module.exports = __webpack_public_path__ + "img/case-ih-logo.15bc1d09.jpg";